import { render, staticRenderFns } from "./OrdersRoundsList.vue?vue&type=template&id=5fc7c1fa&"
import script from "./OrdersRoundsList.vue?vue&type=script&lang=js&"
export * from "./OrdersRoundsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports